var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{staticClass:"layout-header"}),_c('div',{staticClass:"layout-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }